import * as api from '../util/apis';
import { ENV } from '../constants/Constants';

export const getRefundData = async (clientId) => {
	try {
		const resp = await api.getapiresponses(`${ENV.dev.refund}?clientId=${clientId}`);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const refundPayment = async (refundId, data) => {
	try {
		const resp = await api.putapiresponses(
			`${ENV.dev.refund}/${refundId}/payment`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const refundClientPayment = async (refundId, data) => {
	try {
		const resp = await api.putapiresponses(
			`${ENV.dev.refund}/${refundId}/client-payment`,
			data,
		);
		return Promise.resolve(resp.data.data);
	} catch (error) {
		return Promise.reject(error);
	}
};
